export default {
  lang: { fr: "Français", en: "English", it: "Italiano", ar: "العربية" },
  common: {
    loading: "Loading…",
    size: "Size",
    sizeX: "Size {{size}} × {{n}}",
    subtotal: "Subtotal",
    delivery: "Delivery",
    free: "Free",
    total: "Total",
    backToShop: "Back to the boutique",
    discoverShop: "Discover the boutique",
    added: "{{name}} added to cart",
    quickAdd: "Quick add",
    pieces1: "{{n}} piece",
    piecesN: "{{n}} pieces",
  },
  sizes: { custom: "Made-to-measure", onesize: "One size", years: "{{n}}Y" },
  nav: { man: "Men", woman: "Women", couple: "Couple Sets", kids: "Children", leather: "Leather Goods", essayage: "AI Try-On", maison: "The House", surmesure: "Bespoke" },
  tryon: {
    eyebrow: "The B.KOSS Experience",
    titlePre: "Virtual",
    titleIt: "Try-On",
    intro: "Compose your outfit, upload your photo, and our artificial intelligence dresses you in three views — front, profile, back — before you even order.",
    step1: "Step 01",
    tenueTitle: "Your outfit",
    emptyTenue: "No pieces selected — browse the catalogue below or use the “Try on” button on any piece.",
    all: "All",
    maxPieces: "Up to 4 pieces per outfit",
    clear: "Remove all",
    step2: "Step 02",
    photoTitle: "Your photo",
    tip1: "Front-facing photo, full body visible",
    tip2: "Well lit, natural light preferred",
    tip3: "Neutral outfit, simple background",
    upload: "Upload my photo",
    retake: "Change photo",
    photoOk: "Photo received",
    errPhoto: "Invalid photo — take a front-facing, well-lit photo (JPG/PNG, 10 MB max)",
    consent: "I agree that my photo may be used solely to generate this try-on and will be automatically deleted within 24 hours.",
    needConsent: "Please accept the use of your photo to continue",
    generate: "Generate my try-on",
    generating: "Our digital ateliers are dressing your silhouette…",
    progress: "{{n}}/3 views prepared",
    viewHint: "Drag to rotate 360°",
    resultEyebrow: "Your try-on",
    resultTitle: "The outfit suits you",
    download: "Download",
    share: "Share",
    shareText: "My B.KOSS virtual try-on — The Mark of Great Men",
    addToCart: "Add outfit to cart",
    addedCart: "Outfit added to cart",
    modify: "Change selection",
    report: "Report an issue",
    errDaily: "Your free try-ons for today are used up — book an appointment at the atelier for a private fitting",
    errGeneric: "Could not generate — check your photo (front-facing, well lit) and try again",
    tried: "{{name}} added to your try-on",
    footerNote: "Each try-on is a digital interpretation — for a private fitting with our master tailors, book an appointment at the atelier.",
    shopCta: "Shop the collection",
    videoButton: "360° Film",
    videoBusy: "Our studio is filming your silhouette…",
    videoHint: "AI-generated film — allow 2 to 4 minutes",
    videoError: "The film could not be generated — please try again",
    backToViews: "Back to images",
  },
  header: {
    slogan: "The Mark of Great Men",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    openCart: "Open cart",
    city: "Abidjan — Côte d'Ivoire",
    lang: "Language",
  },
  footer: {
    description: "A couture house born in Abidjan. Exceptional ready-to-wear, bespoke pieces and accessories crafted for those who leave their mark on their era.",
    emailPh: "Your e-mail address",
    join: "Join",
    circle: "The B.KOSS Circle — our collections in preview",
    shopCol: "Boutique",
    catCouple: "Couple Sets",
    catLeather: "Leather Goods & Accessories",
    allPieces: "All pieces",
    presse: "Press & Fairs",
    maisonCol: "The House",
    addr1: "Riviera Jardin, opposite Groupe Scolaire Les Jasmins",
    addr2: "Cocody — Abidjan, Côte d'Ivoire",
    rights: "All rights reserved",
    nlOk: "Subscription confirmed",
    nlOkDesc: "You will receive our collections in preview.",
    nlErr: "Subscription failed — please check your address.",
  },
  marquee: { m1: "The Mark of Great Men", m2: "Abidjan", m3: "Haute Couture", m4: "Bespoke", m5: "Côte d'Ivoire", m6: "From the Atelier" },
  home: {
    heroEyebrow: "Couture house — Abidjan, Côte d'Ivoire",
    t1: "The Mark",
    t2pre: "of",
    t2it: "Great",
    t3: "Men",
    heroText: "Exceptional couture crafted in Abidjan. Ready-to-wear, bespoke pieces and accessories for those who leave a mark as they pass.",
    ctaCollection: "Discover the collection",
    ctaSurmesure: "Bespoke",
    scroll: "Scroll",
    videoCard: "Éburnie — The signature set",
    soundOn: "Unmute the film",
    soundOff: "Mute the film",
    colEyebrow: "The Collections",
    colPre: "Choose your",
    colIt: "category",
    viewAll: "All pieces",
    bentoManSub: "{{n}} pieces — Shirts, polos, tunics, trousers",
    bentoWomanSub: "{{n}} pieces — Sovereign elegance",
    bentoCoupleSub: "{{n}} pieces — Matching complicity",
    bentoKidsSub: "{{n}} pieces — The Greats of tomorrow",
    bentoLeatherSub: "{{n}} pieces — The signing detail",
    atelierEyebrow: "The Atelier",
    atelierTitle: "Bespoke",
    atelierText: "A piece cut for you alone, in the hands of our master tailors in Abidjan.",
    bookRdv: "Book an appointment",
    spotEyebrow: "Piece of the month",
    viewPiece: "View the piece",
    maisonEyebrow: "The House",
    maisonPre: "Born in Abidjan,",
    maisonIt: "worn by the world",
    maisonText: "From Cocody to international fairs, B.KOSS carries Ivorian couture where it was least expected. The only African brand at the 98th EXPORIVASCHUH GADABAGS international leather goods fair in Italy in 2023, and invited to NY NOW in New York the same year — the House writes luxury with its own signs.",
    c1Sub: "Home house",
    c2Sub: "EXPORIVASCHUH '23",
    c3Sub: "NY NOW '23",
    maisonCta: "Discover the House",
    bandEyebrow: "By appointment",
    bandPre: "Your silhouette,",
    bandIt: "cut to last",
    bandCta: "Book an appointment",
    newsEyebrow: "New arrivals",
    newsPre: "Latest",
    newsIt: "arrivals",
  },
  boutique: {
    eyebrow: "The Boutique",
    allPre: "All",
    allPost: "pieces",
    allTitle: "All pieces",
    filterAll: "All",
    sortNew: "New arrivals",
    sortAsc: "Price ascending",
    sortDesc: "Price descending",
    families: "Families:",
    empty: "No pieces in this category yet.",
  },
  product: {
    notFound: "This piece cannot be found.",
    backLink: "The Boutique",
    size: "Size",
    qtyMinus: "Decrease quantity",
    qtyPlus: "Increase quantity",
    addToCart: "Add to cart — {{price}}",
    info1: "Express delivery offered in Abidjan (24–48h). Tracked international shipping.",
    info2: "Secure Mobile Money payment — Wave, Orange, MTN, Moov.",
    info3: "Free alterations in boutique. Lifetime fit guarantee.",
    craft: "Craftsmanship",
    craftText: "{{fabric}}. Every piece passes through the hands of our master tailors at the B.KOSS atelier in Riviera Jardin, Cocody. Hand finishing, piece-by-piece checks, woven monogram.",
    customAcc: "Bespoke",
    customText: "This piece also exists to your measurements. Book an appointment with the atelier: measurements taken, fabrics chosen, two fittings, delivery within three weeks.",
  },
  cart: {
    title: "Your Cart",
    empty: "Your cart is empty.",
    checkout: "Checkout",
    momoNote: "Mobile Money — Wave · Orange · MTN · Moov",
    remove: "Remove {{name}}",
    decrease: "Decrease",
    increase: "Increase",
  },
  checkout: {
    eyebrow: "Checkout",
    pre: "Your",
    it: "order",
    s1: "I. Your details",
    fullName: "Full name",
    email: "E-mail",
    phone: "Phone",
    country: "Country",
    city: "City",
    address: "Delivery address",
    note: "Note for the atelier (optional)",
    phName: "Koffi Adjamé",
    phEmail: "you@example.com",
    phPhone: "+225 07 00 00 02 12",
    phCity: "Abidjan",
    phAddress: "Riviera Jardin, Cocody…",
    phMomo: "07 00 00 02 12",
    countryCi: "Côte d'Ivoire",
    countryFr: "France",
    countryUs: "United States",
    countryOther: "Other",
    s2: "II. Payment",
    momoTitle: "Mobile Money",
    momoVia: "— via NicePay",
    momoSub: "Receive a payment request on your phone and confirm with your secret code.",
    operator: "Operator",
    momoPhone: "Mobile Money number",
    cardTitle: "Card payment",
    cardVia: "— secured via Stripe",
    cardSub: "Visa, Mastercard… Amounts converted from FCFA at fixed parity (1 € = 655.957 FCFA).",
    codTitle: "Pay on delivery",
    codSub: "Pay for your order upon receipt, in cash or by Mobile Money.",
    recap: "Summary",
    momoErr: "Enter the Mobile Money number to charge.",
    orderErr: "The order could not be saved.",
    confirming: "Confirming…",
    submit: "Confirm order",
    secure: "Secure payment — Guaranteed authenticity",
  },
  confirmation: {
    paidTitle: "Thank you.",
    pendingTitle: "Order received.",
    ref: "Reference",
    simBadge: "Simulation mode — real Mobile Money payments upon NicePay merchant account activation",
    cardPending: "Card payment awaiting Stripe confirmation — this page updates automatically.",
    momoSim: "Simulated Mobile Money payment request: you would receive a notification on your phone. Confirm with your secret code.",
    validated: "I have approved the payment",
    payNow: "Pay now — Mobile Money",
    verifying: "Verifying…",
    payOk: "Payment confirmed. Thank you.",
    payPending: "Payment still pending validation.",
    payErr: "Unable to verify payment.",
    notFound: "Order not found.",
    deliveryNote: "Express delivery within 24–48h in Abidjan",
    continue: "Continue shopping",
  },
  maison: {
    heroEyebrow: "The House of B.KOSS",
    heroPre: "The legacy",
    heroIt: "of Abidjan",
    storyTitlePre: "Couture as",
    storyTitleIt: "a mother tongue",
    story1: "B.KOSS was born in Abidjan, between the rows of fabrics in the Riviera Jardin atelier and the skyscrapers of the Plateau. The House dresses those who build, decide and shine — the Great Men and Great Women of their time.",
    story2: "Recognised far beyond Ivorian borders, the House was the only African brand at the 98th EXPORIVASCHUH GADABAGS international leather goods fair in Italy in 2023, before being invited to NY NOW in New York. Yet every piece is still crafted here, in Cocody, by the hands of our master tailors.",
    quote: "“Luxury is not about having everything. It is about being unique.”",
    valEyebrow: "Our Commitments",
    valPre: "The perfect gesture, without",
    valIt: "compromise",
    v1t: "Bespoke",
    v1d: "Measurements taken, fabrics chosen, two fittings: your piece belongs to you alone.",
    v2t: "Hand Embroidery",
    v2d: "Baoulé motifs in gold thread, worked by needle by our embroiderers in Cocody.",
    v3t: "Noble Materials",
    v3d: "Cool wools, duchess silks, full-grain leathers — selected without compromise.",
    rdvEyebrow: "Appointments",
    rdvPre: "Book an appointment",
    rdvIt: "at the atelier",
    rdvText: "Bespoke, alterations or image consulting: meet us in our private salon in Riviera Jardin, opposite Groupe Scolaire Les Jasmins, Cocody — Abidjan. Open Monday to Saturday, 9am–7pm.",
    fName: "Full name",
    fEmail: "E-mail",
    fPhone: "Phone",
    fService: "Service",
    svc1: "Bespoke",
    svc2: "Alterations",
    svc3: "Image consulting",
    svc4: "Grand occasions",
    fDate: "Preferred date",
    fProject: "Your project (optional)",
    sending: "Sending…",
    submit: "Request my appointment",
    ok: "Request sent — reference {{ref}}",
    okDesc: "The atelier will call you back within 24h to confirm.",
    err: "Sending failed — please check your details.",
  },
  presse: {
    eyebrow: "Press & Fairs",
    pre: "The House",
    it: "in the spotlight",
    intro: "Born in Abidjan, B.KOSS carries Ivorian couture onto the greatest international stages of fashion and leather goods. Two major events marked the House's 2023.",
    milanCity: "Milan — Italy",
    milanEdition: "98th edition · January 2023",
    milanP1: "In January 2023, B.KOSS stepped for the first time through the doors of an international leather goods fair: the 98th edition of EXPORIVASCHUH GADABAGS, in Italy. A first for the House — and a first for the continent: B.KOSS was the only African brand present.",
    milanP2: "Bags, wallets and high-end leather travel accessories were presented to buyers from around the world, alongside the sector's great houses.",
    milanQ1: "Our stand attracted many visitors, curious about our pieces.",
    milanQ2: "Buyers were impressed by the quality of our products and our commitment to high-end materials and exceptional craftsmanship.",
    nyCity: "New York — United States",
    nyEdition: "August 13 – 16, 2023",
    nyP1: "Six months later, the House headed to New York for NY NOW, one of the major fashion and design gatherings in the United States, from August 13 to 16, 2023.",
    nyP2: "B.KOSS presented its models dyed in African colours, bringing the Ivorian signature to the heart of Manhattan.",
    nyQ1: "All this thanks to your support. Together, let us reveal fashion in a different way and take on even greater challenges.",
    quoteBy: "The House of B.KOSS",
    nextPre: "Next step:",
    nextIt: "your wardrobe",
    cta: "Discover the collection",
  },
  errors: { boundary: "A seam has come undone.", back: "Back to home" },
};
